'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = renderComponents;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _themeProvider = require('@spp/theme-provider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultThemeProviderConfig = function defaultThemeProviderConfig() {
    return {
        whitelabelThemes: {},
        localThemes: {}
    };
};

/**
 * Map components provided by iris to react components, using the given component mapping table.
 * Example component mapping:
 * <pre><code>
 * {
 *   fact: {                            // Type
 *     default: {                       // Subtype or 'default'
 *       component: Factbox,            // React component to use
 *       props: { expandBy: 'button' }, // Props to send along to the component (optional)
 *       children: {                    // Mapping for the components children (optional)
 *         text: {
 *           default: { component: FactboxText },
 *         },
 *       },
 *     },
 *   },
 *   ...
 * };
 * <code/><pre/>
 *
 * @param {Array.<Object>} irisComponents an array of components having at least
 *        a type property, optionally subtype
 * @param {Object} componentMapping defines how to map iris components to react components
 *        based on component type & subtype
 * @param {Object} themeProviderConfig will be passed on to the {@link SelectedThemeProvider}
 *        if the rendered irisComponent has a theme
 * @param {Object} themeProviderConfig.whitelabelThemes
 * @param {Object} themeProviderConfig.localThemes
 * @param {string} parentIdentifier Used for generating unique identifiers passed to the
 *        rendered react components
 */
function renderComponents(irisComponents, componentMapping) {
    var themeProviderConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultThemeProviderConfig();
    var parentIdentifier = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return irisComponents.map(function (irisComponentProps, index) {
        var irisType = irisComponentProps.type,
            _irisComponentProps$s = irisComponentProps.subtype,
            irisSubtype = _irisComponentProps$s === undefined ? 'default' : _irisComponentProps$s;
        var _componentMapping$iri = componentMapping[irisType];
        _componentMapping$iri = _componentMapping$iri === undefined ? {} : _componentMapping$iri;
        var _componentMapping$iri2 = _componentMapping$iri.default,
            subtypeFallback = _componentMapping$iri2 === undefined ? {} : _componentMapping$iri2;
        var _componentMapping$iri3 = componentMapping[irisType];
        _componentMapping$iri3 = _componentMapping$iri3 === undefined ? {} : _componentMapping$iri3;
        var _componentMapping$iri4 = _componentMapping$iri3[irisSubtype],
            componentMap = _componentMapping$iri4 === undefined ? subtypeFallback : _componentMapping$iri4;
        var Component = componentMap.component,
            _componentMap$childre = componentMap.children,
            componentChildrenMap = _componentMap$childre === undefined ? {} : _componentMap$childre,
            _componentMap$props = componentMap.props,
            staticProps = _componentMap$props === undefined ? {} : _componentMap$props;
        var _irisComponentProps$c = irisComponentProps.components,
            componentChildren = _irisComponentProps$c === undefined ? [] : _irisComponentProps$c;


        if (Component) {
            var identifier = parentIdentifier + '-' + index + '-' + irisType + '-' + irisSubtype;
            var themeId = irisComponentProps.theme,
                plainIrisComponentProps = (0, _objectWithoutProperties3.default)(irisComponentProps, ['theme']);

            var renderedComponents = renderComponents(componentChildren, componentChildrenMap, themeProviderConfig, identifier);

            if (themeId) {
                var whitelabelThemes = themeProviderConfig.whitelabelThemes,
                    localThemes = themeProviderConfig.localThemes;


                return _react2.default.createElement(
                    _themeProvider.SelectedThemeProvider,
                    {
                        id: themeId,
                        whitelabelThemesMapping: whitelabelThemes,
                        localThemesMapping: localThemes,
                        key: identifier,
                        identifier: identifier
                    },
                    _react2.default.createElement(
                        Component,
                        (0, _extends3.default)({
                            irisComponents: irisComponents,
                            irisIndex: index
                        }, plainIrisComponentProps, staticProps),
                        renderedComponents
                    )
                );
            }

            return _react2.default.createElement(
                Component,
                (0, _extends3.default)({
                    irisComponents: irisComponents,
                    irisIndex: index
                }, plainIrisComponentProps, staticProps, {
                    key: identifier,
                    identifier: identifier
                }),
                renderedComponents
            );
        }

        return undefined;
    }).filter(function (component) {
        return component;
    });
}
//# sourceMappingURL=render-components.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/lib/cjs/render-components.js
 ** module id = 499
 ** module chunks = 1
 **/